import {OnboardingStyle} from "@components/onboarding/onboarding.style";
import {createStyles, Theme} from "@material-ui/core";

export const NotificationsStyles = (theme: Theme) => createStyles({
    ...OnboardingStyle(theme),
});



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepNotifications/notifications.styles.ts